import { getAnnualDiscountPromoLoginId } from "./annualDiscountPromo";

/**
 * "Your free trial is ready" modal (docs/free-trial-design.md): shown once per login to a
 * user who became trial-eligible. Dismissal is remembered per login id, the same way the
 * annual-discount modal does it, so a new sign-in shows it again.
 */
const STORAGE_KEY = "akinda:trial-promo-v1:modal-dismissed-for";

function readStorage(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // private mode / quota
  }
}

export function wasTrialModalDismissedForCurrentLogin(): boolean {
  return readStorage(STORAGE_KEY) === getAnnualDiscountPromoLoginId();
}

export function dismissTrialModalForCurrentLogin(): void {
  writeStorage(STORAGE_KEY, getAnnualDiscountPromoLoginId());
}
